import { Box, Flex } from '@cowsquare/design';
import QRCode from 'qrcode.react';
import * as R from 'ramda';
import React from 'react';
import { graphql } from 'react-apollo';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { background } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import { GET_HKDU_USER_INFO, GET_USER_INFO } from '../../../apollo/graphql/user';
import defaultAuthorAvatar from '../../../asset/defaultAuthorAvatar.png';

const CardBox = styled(Box).attrs({
  width: '328px',
  height: '480px',
  py: 6,
  px: 5,
  mx: 5,
  my: '48px',
})`
  background-color: ${themeGet('colors.whites.0')};
`;

const Avatar = styled(Box).attrs({
  mb: 5,
  width: '88px',
  height: '88px',
})`
  ${background}
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  border-radius: ${themeGet('radii.4')};
`;

const Name = styled(Box).attrs({
  mb: 5,
})`
  font-size: ${themeGet('fontSizes.h3')};
  font-weight: ${themeGet('fontWeights.semibold')};
`;

const Info = styled(Box).attrs({
  mb: 7,
})`
  color: ${themeGet('colors.blacks.6')};
  font-size: ${themeGet('fontSizes.h5')};
`;

const QRCodeBox = styled(Box).attrs({
  p: 5,
})`
  border: ${themeGet('borders.1')};
  border-color: ${themeGet('colors.blacks.8')};
`;

const MemberCardPage = ({ memberInfo }) => {
  const member = R.pathOr({}, ['user', 0], memberInfo);
  const name = R.pathOr('', ['doctor', 'name'], member);
  const avatar = R.propOr(defaultAuthorAvatar, 'real_avatar', member);
  const no = R.pathOr('', ['doctor', 'hkdu_member_no'], member);

  return (
    <Flex alignItems="center" justifyContent="center">
      <Helmet>
        <title>Member Card - HKDU Members Only</title>
      </Helmet>
      <CardBox>
        <Flex flexDirection="column" alignItems="center" justifyContent="center">
          <Avatar backgroundImage={`url(${avatar})`} />
          <Name>{name}</Name>
          <Info>{`HKDU Membership No : ${no}`}</Info>
          <QRCodeBox>
            <QRCode size={192} value={`${name},${no}`} />
          </QRCodeBox>
        </Flex>
      </CardBox>
    </Flex>
  );
};

export default R.compose(
  graphql(GET_USER_INFO, { name: 'userInfo' }),
  graphql(GET_HKDU_USER_INFO, {
    name: 'memberInfo',
    options: ({ userInfo }) => ({
      variables: {
        id: R.pathOr('', ['user', 'id'], userInfo),
      },
    }),
  })
)(MemberCardPage);
